function sweaterCartGroups(cart, catalog) {
  const mainIds = new Set(catalog.main.variants.map(v => String(v.id)));
  const groups = [];
  for (const item of cart.items) {
    const q = Number(item.quantity);
    const known = mainIds.has(String(item.variant_id));
    const unit = Number(item.original_price || item.price || 0);
    const charge = Number(item.final_line_price);
    const before = Number(item.original_line_price);
    const components = item.item_components || [];
    const physical = components.reduce((s, c) => s + Number(c.quantity || 0), 0);
    const saved = before - charge;
    const free = unit > 0 ? saved / unit : 0;
    const canSplit = known && physical === q * 5 && Number.isInteger(free) && free >= 0 && free <= q && before === unit * q;
    if (canSplit && free > 0 && free < q) {
      groups.push({item, key:item.key + ':paid', quantity:q-free, charge, reference:unit*(q-free), free:false, physical:(q-free)*5});
      groups.push({item, key:item.key + ':free', quantity:free, charge:0, reference:unit*free, free:true, physical:free*5});
    } else {
      groups.push({item, key:item.key, quantity:q, charge, reference:Math.max(before, Number(item.reference_line_price || 0)), free:canSplit && charge === 0, physical:physical || q});
    }
  }
  const sweaterGroups = groups.filter(g => mainIds.has(String(g.item.variant_id))).sort((a,b) => Number(a.free)-Number(b.free));
  let sweaterIndex = 0;
  return groups.map(g => mainIds.has(String(g.item.variant_id)) ? sweaterGroups[sweaterIndex++] : g);
}

if (typeof module !== 'undefined' && module.exports) module.exports = {sweaterCartGroups};

if (typeof document !== 'undefined') (() => {
  const init = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    document.body.classList.add('sweater-context');
    const $ = s => root.querySelector(s);
    const $$ = s => Array.from(root.querySelectorAll(s));
    const data = JSON.parse($('[data-sw-data]').textContent);
    const catalog = data.catalog;
    const t = data.i18n;
    const money = n => new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(n/100);
    const escape = value => String(value == null ? '' : value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const base = window.Shopify?.routes?.root || '/';
    const drawer = document.querySelector('cart-drawer');
    const snapshotNode = document.querySelector('[data-sw-cart-snapshot]');
    const snapshotId = snapshotNode?.dataset.sectionId;
    const contextUrl = new URL(window.location.href);
    contextUrl.searchParams.delete('sections');
    contextUrl.searchParams.delete('section_id');
    const contextPath = contextUrl.pathname + contextUrl.search;
    const findVariant = (lot,size) => catalog.main.variants.find(v=>v.option1===lot && v.option2===size);
    const monoKeys = {'Noir':'black','Crème':'cream','Camel':'camel','Taupe':'taupe','Espresso':'espresso'};
    const mainIds = new Set(catalog.main.variants.map(v=>String(v.id)));
    const variantsById = new Map([catalog.main,...catalog.upsells].filter(Boolean).flatMap(p=>p.variants.map(v=>[String(v.id),{variant:v,product:p}])));
    const form = $('[data-sw-form]');
    const addButton = $('[data-sw-add]');
    let lastCart = null;
    let busy = false;
    let reservationEnd = Number(sessionStorage.getItem('sw-reservation-end')) || 0;

    const selectedOffer = () => Number($('input[name="sw-offer"]:checked').value);
    const updateOffers = () => {
      const offer = selectedOffer();
      $$('[data-sw-offer]').forEach(card=>{
        const active = Number(card.dataset.swOffer)===offer;
        card.classList.toggle('is-selected',active);
        card.querySelector('[data-sw-offer-details]').hidden=!active;
        card.querySelectorAll('select').forEach(select=>select.disabled=!active);
      });
    };
    form.addEventListener('change',updateOffers);
    updateOffers();

    const mainPhoto = $('[data-sw-hero-img]');
    const zoom = $('[data-sw-zoom]');
    $$('[data-sw-thumb]').forEach(button=>button.addEventListener('click',()=>{
      mainPhoto.src=button.dataset.src;
      mainPhoto.srcset=button.dataset.srcset;
      mainPhoto.alt=button.dataset.alt;
      $$('[data-sw-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    }));
    const moveGallery=delta=>{
      const thumbs=$$('[data-sw-thumb]');
      const current=thumbs.findIndex(b=>b.getAttribute('aria-pressed')==='true');
      const next=thumbs[(current+delta+thumbs.length)%thumbs.length];
      next.click();next.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
    };
    $('[data-sw-gallery-prev]').addEventListener('click',()=>moveGallery(-1));
    $('[data-sw-gallery-next]').addEventListener('click',()=>moveGallery(1));
    const testimonialTrack=$('.sw-testimonial-track');
    $('[data-sw-testimonial-prev]').addEventListener('click',()=>testimonialTrack.scrollBy({left:-testimonialTrack.clientWidth,behavior:'smooth'}));
    $('[data-sw-testimonial-next]').addEventListener('click',()=>testimonialTrack.scrollBy({left:testimonialTrack.clientWidth,behavior:'smooth'}));
    $('[data-sw-zoom-open]').addEventListener('click',()=>{
      const image=zoom.querySelector('img');
      image.src=mainPhoto.src;
      image.alt=mainPhoto.alt;
      zoom.showModal();
    });
    zoom.querySelector('button').addEventListener('click',()=>zoom.close());
    zoom.addEventListener('click',event=>{if(event.target===zoom)zoom.close();});
    $$('[data-sw-read-more]').forEach(button=>button.addEventListener('click',()=>{
      const card=button.closest('.sw-testimonial');
      const expanded=card.classList.toggle('is-expanded');
      button.textContent=expanded?t.less:t.more;
      button.setAttribute('aria-expanded',String(expanded));
    }));

    let reviewPage=1;
    const reviewList=$('[data-sw-reviews]');
    const pagination=$('[data-sw-pagination]');
    const sort=$('[data-sw-review-sort]');
    const filterArea=$('[data-sw-review-filters]');
    const renderReviews=()=>{
      const stars=$('[data-sw-rating-filter]:checked')?.value || 'all';
      let reviews=data.reviews.filter(r=>stars==='all'||r.stars===Number(stars));
      if(sort.value==='pictures')reviews=reviews.filter(r=>r.images?.length);
      if(sort.value==='highest')reviews.sort((a,b)=>b.stars-a.stars||b.date.localeCompare(a.date));
      else if(sort.value==='lowest')reviews.sort((a,b)=>a.stars-b.stars||b.date.localeCompare(a.date));
      else reviews.sort((a,b)=>b.date.localeCompare(a.date));
      const pages=Math.max(1,Math.ceil(reviews.length/5));
      reviewPage=Math.min(reviewPage,pages);
      const rows=reviews.slice((reviewPage-1)*5,reviewPage*5);
      reviewList.innerHTML=rows.length?rows.map(r=>`<article class="sw-review"><span class="sw-stars" aria-label="${r.stars}/5">${'★'.repeat(r.stars)}${'☆'.repeat(5-r.stars)}</span><div class="sw-review-meta"><span class="sw-review-initial" aria-hidden="true">${escape(r.author[0])}</span><div><div class="sw-review-author">${escape(r.author)}</div><div class="sw-review-date">${escape(r.displayDate)}</div></div></div>${r.title?`<h3>${escape(r.title)}</h3>`:''}<p>${escape(r.body)}</p></article>`).join(''):`<p>${escape(t.noReviews)}</p>`;
      const nums=Array.from({length:pages},(_,i)=>i+1).filter(n=>n===1||n===pages||Math.abs(n-reviewPage)<=2);
      let previous=0;
      const pageButtons=nums.map(n=>{
        const dots=previous&&n-previous>1?'<span aria-hidden="true">…</span>':'';
        previous=n;
        return dots+`<button type="button" data-review-page="${n}" aria-label="${escape(t.page.replace('{{ page }}',n))}"${n===reviewPage?' aria-current="page"':''}>${n}</button>`;
      }).join('');
      pagination.innerHTML=`<button type="button" data-review-page="${reviewPage-1}" aria-label="${escape(t.previous)}"${reviewPage===1?' disabled':''}>‹</button>${pageButtons}<button type="button" data-review-page="${reviewPage+1}" aria-label="${escape(t.next)}"${reviewPage===pages?' disabled':''}>›</button>`;
    };
    sort.addEventListener('change',()=>{reviewPage=1;renderReviews();});
    $('[data-sw-filter-button]').addEventListener('click',event=>{filterArea.hidden=!filterArea.hidden;event.currentTarget.setAttribute('aria-expanded',String(!filterArea.hidden));});
    filterArea.addEventListener('change',()=>{reviewPage=1;renderReviews();});
    pagination.addEventListener('click',event=>{
      const button=event.target.closest('[data-review-page]');
      if(!button||button.disabled)return;
      reviewPage=Number(button.dataset.reviewPage);
      renderReviews();
      reviewList.scrollIntoView({behavior:'smooth',block:'start'});
    });
    renderReviews();
    const reviewDialog=$('[data-sw-review-dialog]');
    $('[data-sw-write-review]').addEventListener('click',()=>reviewDialog.showModal());
    reviewDialog.querySelector('[data-sw-close-review]').addEventListener('click',()=>reviewDialog.close());
    reviewDialog.addEventListener('click',event=>{if(event.target===reviewDialog)reviewDialog.close();});

    const tagSvg='<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M1 9 9 1h7l3 3v7l-8 8L1 9Zm12-3a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"/></svg>';
    const binSvg='<svg viewBox="0 0 16 20" aria-hidden="true"><path d="M1 4h14M5 4V1h6v3M3 5l1 13h8l1-13M6 7v8M10 7v8"/></svg>';
    const titleFor=(item,known)=>{
      if(mainIds.has(String(item.variant_id))){
        const key=monoKeys[known?.variant.option1];
        return key?t.packTitles[key]:t.title;
      }
      return item.product_title||item.title;
    };
    const variantImage=variant=>variant.featured_image?.src||variant.featured_image?.url||null;
    const upsellMarkup=()=>{
      const halloween=catalog.upsells.filter(Boolean).map(p=>({product:p,variant:p.variants[0]}));
      const colours=['Crème','Camel','Taupe','Espresso','Noir'].map(lot=>({product:catalog.main,variant:findVariant(lot,t.sizeSmall),lot}));
      return [...halloween,...colours].filter(x=>x.product&&x.variant).map(({product,variant,lot})=>{
        const title=lot?t.packTitles[monoKeys[lot]]:product.publicTitle;
        const image=variantImage(variant)||product.image;
        const select=lot?`<select data-sw-upsell-size aria-label="${escape(t.size)} ${escape(title)}"><option value="${escape(t.sizeSmall)}">${escape(t.sizeSmall)}</option><option value="${escape(t.sizeLarge)}">${escape(t.sizeLarge)}</option></select>`:'';
        const url=product.url+'?variant='+variant.id;
        return `<div class="sw-upsell"><a href="${escape(url)}"><img src="${escape(image)}" alt="${escape(title)}" loading="lazy" width="98" height="98"></a><div class="sw-upsell-info"><a class="sw-upsell-title" href="${escape(url)}">${escape(title)}</a><div class="sw-upsell-prices">${variant.compare_at_price>variant.price?`<s>${money(variant.compare_at_price)}</s>`:''}<span>${money(variant.price)}</span></div><div class="sw-upsell-add">${select}<button type="button" data-sw-upsell-id="${variant.id}"${lot?` data-sw-upsell-lot="${escape(lot)}"`:''}>${escape(t.cartAdd)}</button></div></div></div>`;
      }).join('');
    };
    const cartMarkup=cart=>{
      const groups=sweaterCartGroups(cart,catalog);
      const count=cart.items.reduce((n,item)=>n+Number(item.quantity),0);
      const rows=groups.map(group=>{
        const item=group.item;
        const known=variantsById.get(String(item.variant_id));
        const title=titleFor(item,known);
        const size=mainIds.has(String(item.variant_id))?known?.variant.option2:(item.variant_title==='Default Title'?'':item.variant_title);
        const image=item.image||variantImage(known?.variant||{})||known?.product.image;
        const savings=group.reference-group.charge;
        const discount=mainIds.has(String(item.variant_id))&&(group.free||savings>0&&Number(item.original_line_price)>Number(item.final_line_price));
        return `<div class="sw-cart-row" data-sw-row-key="${escape(group.key)}" data-physical-quantity="${group.physical}" data-native-quantity="${item.quantity}"><a href="${escape(item.url)}"><img class="sw-cart-photo" src="${escape(image)}" alt="${escape(title)}" width="96" height="96"></a><div class="sw-cart-copy"><div class="sw-cart-title-row"><a class="sw-cart-title" href="${escape(item.url)}">${escape(title)}</a><button class="sw-cart-remove" type="button" aria-label="${escape(t.remove)} ${escape(title)}" data-sw-change-key="${escape(item.key)}" data-sw-delta="${-group.quantity}">${binSvg}</button></div>${size?`<div class="sw-cart-size">${mainIds.has(String(item.variant_id))?escape(t.size)+' : ':''}${escape(size)}</div>`:''}<div class="sw-cart-prices">${savings>0?`<s>${money(group.reference)}</s>`:''}<span>${money(group.charge)}</span>${savings>0?`<span class="sw-cart-saving">(${escape(t.save)} ${money(savings)})</span>`:''}</div><div class="sw-cart-controls"><div class="sw-quantity"><button type="button" aria-label="${escape(t.decrease)}" data-sw-change-key="${escape(item.key)}" data-sw-delta="-1">−</button><input aria-label="${escape(t.quantity)}" type="number" min="0" value="${group.quantity}" data-sw-input-key="${escape(item.key)}" data-sw-group-quantity="${group.quantity}"><button type="button" aria-label="${escape(t.increase)}" data-sw-change-key="${escape(item.key)}" data-sw-delta="1">+</button></div>${discount?`<span class="sw-discount-tag">${tagSvg}${escape(t.offer)}</span>`:''}</div></div></div>`;
      }).join('');
      const savings=Number(cart.total_discount)||cart.items.reduce((sum,item)=>sum+Number(item.original_line_price)-Number(item.final_line_price),0);
      const discounts=[...new Set([...cart.items.flatMap(item=>(item.discount_allocations||[]).map(d=>d.discount_application?.title)),...(cart.cart_level_discount_applications||[]).map(d=>d.title)].filter(Boolean))];
      const discountLabel=discounts.join(' · ');
      return `<div class="sw-cart-head"><h2>${escape(t.cartTitle)} • ${count}</h2><button class="sw-cart-close" type="button" aria-label="${escape(t.cartClose)}" data-sw-cart-close>×</button></div>${cart.items.length?`<div class="sw-reservation">${escape(t.reserved)} <span data-sw-timer></span></div><div class="sw-cart-body">${rows}<div class="sw-upsells">${upsellMarkup()}</div></div><div class="sw-cart-foot">${savings>0?`<div class="sw-cart-savings"><span>${escape(t.savings)}</span><span class="sw-discount-tag">${tagSvg}${escape(discountLabel||(groups.some(g=>g.free)?t.offer:t.save))}</span><strong>− ${money(savings)}</strong></div>`:''}<a class="sw-cart-checkout" href="${base}checkout">${escape(t.checkout)} • ${money(cart.total_price)}</a><p class="sw-cart-error" data-sw-cart-error hidden></p></div>`:`<div class="sw-cart-empty">${escape(t.empty)}</div>`}`;
    };
    const tick=()=>{
      const seconds=Math.max(0,Math.ceil((reservationEnd-Date.now())/1000));
      const value=String(Math.floor(seconds/60)).padStart(2,'0')+':'+String(seconds%60).padStart(2,'0');
      drawer?.querySelectorAll('[data-sw-timer]').forEach(n=>n.textContent=value);
    };
    const renderCart=cart=>{
      if(!drawer)return;
      lastCart=cart;
      const inner=drawer.querySelector('.drawer__inner');
      if(!inner)return;
      let panel=inner.querySelector('.sw-cart');
      if(!panel){panel=document.createElement('div');panel.className='sw-cart';inner.append(panel);}
      panel.innerHTML=cartMarkup(cart);
      panel.dataset.busy=String(busy);
      drawer.classList.toggle('is-empty',!cart.items.length);
      drawer.querySelector('cart-drawer-items')?.classList.toggle('is-empty',!cart.items.length);
      panel.querySelector('[data-sw-cart-close]').addEventListener('click',()=>drawer.close());
      const count=cart.items.reduce((n,item)=>n+Number(item.quantity),0);
      const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
      if(bubble)bubble.textContent=String(count);
      tick();
    };
    const loadCart=async()=>{
      if(!snapshotId)throw new Error('Missing cart section');
      const url=new URL(contextUrl.href);
      url.searchParams.set('section_id',snapshotId);
      url.searchParams.set('_sw',String(Date.now()));
      const response=await fetch(url.href,{headers:{Accept:'text/html'},cache:'no-store'});
      if(!response.ok)throw new Error('Cart snapshot unavailable');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const node=doc.querySelector('[data-sw-cart-snapshot]');
      if(!node)throw new Error('Cart snapshot absent');
      const cart=JSON.parse(node.textContent);
      if(!Array.isArray(cart.items)||!Number.isFinite(cart.total_price))throw new Error('Invalid cart snapshot');
      return cart;
    };
    const sections=()=>drawer.getSectionsToRender().map(s=>s.id);
    const mutate=async(endpoint,payload)=>{
      const response=await fetch(base+'cart/'+endpoint+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({...payload,sections:sections(),sections_url:contextPath})});
      const result=await response.json();
      if(!response.ok||result.status)throw new Error(t.cartError);
      drawer.renderContents(result);
      const cart=await loadCart();
      renderCart(cart);
      return cart;
    };
    const setBusy=value=>{
      busy=value;
      if(addButton)addButton.disabled=value;
      drawer?.querySelector('.sw-cart')?.setAttribute('data-busy',String(value));
    };
    const showCartError=()=>{
      const error=drawer?.querySelector('[data-sw-cart-error]');
      if(error){error.textContent=t.cartError;error.hidden=false;}
    };
    const add=async(items,button)=>{
      if(busy)return;
      if(!drawer||typeof drawer.renderContents!=='function'||typeof drawer.getSectionsToRender!=='function')throw new Error(t.addError);
      setBusy(true);
      $('[data-sw-error]').hidden=true;
      const previous=button.textContent;
      button.disabled=true;
      button.textContent=button===addButton?t.adding:t.cartBusy;
      try{
        drawer.setActiveElement?.(button);
        if(!reservationEnd||reservationEnd<Date.now()){
          reservationEnd=Date.now()+600000;
          sessionStorage.setItem('sw-reservation-end',String(reservationEnd));
        }
        await mutate('add',{items});
        drawer.open();
      }catch(error){
        const node=$('[data-sw-error]');node.textContent=t.addError;node.hidden=false;
        showCartError();
      }finally{
        button.textContent=previous;button.disabled=false;setBusy(false);
      }
    };
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const offer=selectedOffer();
      const card=$(`[data-sw-offer="${offer}"]`);
      const sizes=Array.from(card.querySelectorAll('select')).map(s=>s.value);
      const lot=root.dataset.lot;
      const first=findVariant(lot,sizes[0]);
      const second=offer===10?findVariant(lot,sizes[1]):null;
      if(!first||offer===10&&!second)return;
      const uuid=crypto.randomUUID();
      const items=[{id:first.id,quantity:1,properties:{_sw_uuid:uuid,_sw_group:'first5'}}];
      if(second)items.push({id:second.id,quantity:1,properties:{_sw_uuid:uuid,_sw_group:'second5'}});
      add(items,addButton);
    });
    drawer?.addEventListener('click',async event=>{
      const change=event.target.closest('[data-sw-change-key]');
      const upsell=event.target.closest('[data-sw-upsell-id]');
      if(change){
        if(busy||!lastCart)return;
        const item=lastCart.items.find(i=>i.key===change.dataset.swChangeKey);
        if(!item)return;
        const quantity=Math.max(0,Number(item.quantity)+Number(change.dataset.swDelta));
        setBusy(true);
        try{await mutate('change',{id:item.key,quantity});}catch(error){showCartError();}finally{setBusy(false);}
      }else if(upsell){
        const lot=upsell.dataset.swUpsellLot;
        const size=upsell.closest('.sw-upsell').querySelector('select')?.value;
        const variant=lot?findVariant(lot,size):variantsById.get(upsell.dataset.swUpsellId)?.variant;
        if(variant)add([{id:variant.id,quantity:1,properties:{_sw_uuid:crypto.randomUUID(),_sw_group:'upsell'}}],upsell);
      }
    });
    drawer?.addEventListener('change',async event=>{
      const input=event.target.closest('[data-sw-input-key]');
      if(!input||busy||!lastCart)return;
      const item=lastCart.items.find(i=>i.key===input.dataset.swInputKey);
      if(!item)return;
      const value=Number(input.value);
      if(!Number.isInteger(value)||value<0){input.value=input.dataset.swGroupQuantity;return;}
      const quantity=Math.max(0,Number(item.quantity)+value-Number(input.dataset.swGroupQuantity));
      setBusy(true);
      try{await mutate('change',{id:item.key,quantity});}catch(error){showCartError();}finally{setBusy(false);}
    });
    if(snapshotNode){try{renderCart(JSON.parse(snapshotNode.textContent));}catch(error){}}
    const cartContainer=document.querySelector('#CartDrawer');
    if(cartContainer){new MutationObserver(()=>{if(lastCart&&!drawer.querySelector('.sw-cart'))renderCart(lastCart);}).observe(cartContainer,{childList:true});}
    if(drawer){new MutationObserver(()=>{if(drawer.classList.contains('active')&&lastCart&&!drawer.querySelector('.sw-cart'))renderCart(lastCart);}).observe(drawer,{attributes:true,attributeFilter:['class']});}
    setInterval(tick,1000);
    addButton.disabled=false;
  };
  const start=()=>document.querySelectorAll('[data-sw-page]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();
